import $ from '../utils/jquery';

// Load slick as a script that attaches to global jQuery (avoids CommonJS bundling issues)
const loadSlick = () => {
	return new Promise((resolve) => {
		// Check if slick is already loaded
		if ($.fn.slick) {
			resolve();
			return;
		}
		// Load slick dynamically
		const script = document.createElement('script');
		script.src = '/wp-content/themes/sao-2026/assets/scripts/slick.min.js';
		script.onload = resolve;
		document.head.appendChild(script);
	});
};

const $carousel = $( '#lawmakers-carousel' );

const getDirection = function( nextSlide, currentSlide ) {
	if ( nextSlide > currentSlide ) {
		return 'next';
	} else {
		return 'prev';
	}
}

const nextArrow = `<button class="slick-arrow slick-next">
	<span class="sr-only">Next</span>
	<i class="fas fa-chevron-right"></i>
</button>`;

const prevArrow = `<button class="slick-arrow slick-prev">
	<span class="sr-only">Previous</span>
	<i class="fas fa-chevron-left"></i>
</button>`;


const bind = () => {
	$( '.slick-prev' ).prop( 'disabled', true );

	$( '#lawmakers-carousel .slides-wrapper' ).slick( {
		slidesToShow: 3,
		slidesToScroll: 1,
		centerMode: true,
		arrows: false,
		asNavFor: '#lawmakers-carousel .cards-wrapper',
		responsive: [
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 1
				}
			}
		]
	} ).on( 'beforeChange', function( e, slick, currentSlide, nextSlide ) {
		var direction = getDirection( nextSlide, currentSlide );

		if ( direction === 'next' ) {
			$( '.slick-prev' ).prop( 'disabled', false );

			if ( nextSlide === slick.slideCount - 1 ) {
				$( '.slick-next' ).prop( 'disabled', true );
			}
		}

		if ( direction === 'prev' ) {
			$( '.slick-next' ).prop( 'disabled', false );

			if ( nextSlide === 0 ) {
				$( '.slick-prev' ).prop( 'disabled', true );
			}
		}
	} );

	$( '#lawmakers-carousel .cards-wrapper' ).slick( {
		slidesToShow:1,
		slidesToScroll: 1,
		fade: true,
		speed: 500,
		nextArrow,
		prevArrow,
		dots: true,
		asNavFor: '#lawmakers-carousel .slides-wrapper'
	} );
};

export default async () => {
	if ( ! $carousel.length ) {
		return;
	}

	await loadSlick();
	bind();
};
